import script from "./BaseButtonWithBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseButtonWithBadge.vue?vue&type=script&setup=true&lang=js"

import "./BaseButtonWithBadge.vue?vue&type=style&index=0&id=28758a53&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28758a53"]])

export default __exports__